import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { CarrierMember } from 'contracts/CarrierMembers';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_CARRIER_MEMBER_',
  }
);

export interface FetchCarrierMemberState {
  data: CarrierMember | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCarrierMemberRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: CarrierMember;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCarrierMemberState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCarrierMemberState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchCarrierMemberState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchCarrierMemberState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCarrierMemberState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCarrierMember = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCarrierMemberTypes = Types;
export const FetchCarrierMemberActions = Creators;
